import { createContext, type FC, type PropsWithChildren, useMemo } from 'react';

import { useMe, usePermissionsQuery } from './Permissions.request';
import type { IPermissionsProvider, Permissions } from './Permissions.types';

export const PermissionsContext = createContext<IPermissionsProvider | undefined>(undefined);

const PermissionsProvider: FC<PropsWithChildren> = ({ children }) => {
	const { data: me } = useMe();
	const { data: permissions = {} as Permissions, isLoading: isLoadingPermissions, ...rest } = usePermissionsQuery();

	const value = useMemo(
		() => ({ me, permissions, isLoading: isLoadingPermissions, ...rest }),
		[me, permissions, isLoadingPermissions, rest],
	);

	if (isLoadingPermissions) {
		return (
			<div className="flex min-h-screen items-center justify-center bg-white text-default">
				<div className="h-md w-md animate-pulse rounded-full bg-grey-25" />
			</div>
		);
	}

	return <PermissionsContext.Provider value={value}>{children}</PermissionsContext.Provider>;
};

export default PermissionsProvider;
